import { render } from "./VideoUpload.vue?vue&type=template&id=3e121455&scoped=true"
import script from "./VideoUpload.vue?vue&type=script&lang=js"
export * from "./VideoUpload.vue?vue&type=script&lang=js"

import "./VideoUpload.vue?vue&type=style&index=0&id=3e121455&lang=scss&scoped=true"

import exportComponent from "/home/ak/projects/ysm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e121455"]])

export default __exports__